/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedCrossIcon16Light = forwardRef('MedCrossIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3V2Zm5 0H6v3.5a.5.5 0 0 1-.5.5H2v4h3.5a.5.5 0 0 1 .5.5V14h4v-3.5a.5.5 0 0 1 .5-.5H14V6h-3.5a.5.5 0 0 1-.5-.5V2Z" })));
});
